var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1048_840)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1048_840",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11C6.65674 11.0009 7.30717 10.8719 7.91391 10.6206C8.52065 10.3693 9.07174 10.0005 9.5355 9.5355C10.0005 9.07174 10.3693 8.52065 10.6206 7.91391C10.8719 7.30717 11.0009 6.65674 11 6C11.0008 5.34327 10.8719 4.69285 10.6206 4.08611C10.3692 3.47937 10.0005 2.92828 9.5355 2.4645C9.07174 1.99951 8.52065 1.63075 7.91391 1.37943C7.30717 1.1281 6.65674 0.999153 6 1C5.34327 0.999167 4.69285 1.12812 4.08611 1.37944C3.47937 1.63077 2.92828 1.99952 2.4645 2.4645C1.99952 2.92828 1.63077 3.47937 1.37944 4.08611C1.12812 4.69285 0.999167 5.34327 1 6C0.999153 6.65674 1.1281 7.30717 1.37943 7.91391C1.63075 8.52065 1.99951 9.07174 2.4645 9.5355C2.92828 10.0005 3.47937 10.3692 4.08611 10.6206C4.69285 10.8719 5.34327 11.0008 6 11Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6L5.5 7.5L8.5 4.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1048_840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0V0Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1048_840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle-tick.a8349897464a5234e7d6ac2db1d19a18.svg";
export { ForwardRef as ReactComponent };